/**
 * Mapeamento do tileset Wang água→margem — GERADO da metadata do PixelLab
 * (assets-src/art/sources/tileset_river.metadata.json; proveniência em
 * assets-src/art/provenance/tileset_river.json).
 *
 * Índice: bitmask dos cantos NW<<3 | NE<<2 | SW<<1 | SE, com terra(upper)=1.
 * Valor: retângulo do tile na folha (bounding_box exato — nunca derivar do
 * nome wang nominal; é o que produz banding, avisa o gerador).
 */
export interface WangFrame {
  readonly x: number
  readonly y: number
  readonly w: number
  readonly h: number
}

export const WANG_FRAMES: readonly WangFrame[] = [
  { x: 32, y: 16, w: 16, h: 16 }, // 0000 = NW NE SW SE
  { x: 48, y: 16, w: 16, h: 16 }, // 0001 = NW NE SW SE
  { x: 32, y: 32, w: 16, h: 16 }, // 0010 = NW NE SW SE
  { x: 16, y: 32, w: 16, h: 16 }, // 0011 = NW NE SW SE
  { x: 32, y: 0, w: 16, h: 16 }, // 0100 = NW NE SW SE
  { x: 48, y: 32, w: 16, h: 16 }, // 0101 = NW NE SW SE
  { x: 0, y: 16, w: 16, h: 16 }, // 0110 = NW NE SW SE
  { x: 48, y: 48, w: 16, h: 16 }, // 0111 = NW NE SW SE
  { x: 16, y: 16, w: 16, h: 16 }, // 1000 = NW NE SW SE
  { x: 32, y: 48, w: 16, h: 16 }, // 1001 = NW NE SW SE
  { x: 16, y: 0, w: 16, h: 16 }, // 1010 = NW NE SW SE
  { x: 0, y: 32, w: 16, h: 16 }, // 1011 = NW NE SW SE
  { x: 48, y: 0, w: 16, h: 16 }, // 1100 = NW NE SW SE
  { x: 0, y: 0, w: 16, h: 16 }, // 1101 = NW NE SW SE
  { x: 16, y: 48, w: 16, h: 16 }, // 1110 = NW NE SW SE
  { x: 0, y: 48, w: 16, h: 16 }, // 1111 = NW NE SW SE
]
